import React, { useState, useEffect } from 'react';
import MasterButton, { ButtonLayoutType, ButtonSize, ButtonVariation } from "../../../components/button/MasterButton";
import RightArrow from "../../../assets/RightArrow.svg"

import { convertTimeString } from "../../../utils/TimeUtils"

import "./dashboardParticipantInnerDetail.css";

interface HoverModalProps {
    cnt_indeterminate?: number;
    cnt_pos?: number;
    participant_name: string;
    last_updated_date: string;
    timeline: string;
}

function convertToHoursAndMinutes(intervals: number): string {
    const totalMinutes = intervals * 5;
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
  
    if (hours > 0 && minutes > 0) {
      return `${hours}h ${minutes}min`;
    } else if (hours > 0) {
      return `${hours}h`;
    } else {
      return `${minutes}min`;
    }
}

const DashboardParticipantInnerDetail: React.FC<HoverModalProps> = ({ cnt_indeterminate = 0, cnt_pos = 0, participant_name, last_updated_date, timeline }) => {
    const [isAnomalous, setIsAnomalous] = useState(false);
    const [anomaly, setAnomaly] = useState(0);
    const [warnings, setWarnings] = useState(0);

    useEffect(() => {
        let timePeriod = 7;
        
        if (timeline === "Today") {
            timePeriod = 1;
        } else if (timeline === "1 Week") {
            timePeriod = 7;
        } else if (timeline === "1 Month") {
            timePeriod = 30;
        } else if (timeline === "All Time") {
            timePeriod = 1000;
        }

        const totalcounts = timePeriod * 24 * 12;

        const anomalyPercentage = (cnt_pos / totalcounts) * 100; 
        const warningPercentage = ((cnt_indeterminate / totalcounts) * 100) + anomalyPercentage;

        setAnomaly(anomalyPercentage);
        setWarnings(warningPercentage);

        if (cnt_indeterminate || cnt_pos) {
            setIsAnomalous(true);
        } else {
            setIsAnomalous(false);
        }
    }, [cnt_indeterminate, cnt_pos, timeline]);

    return (
        <div className='dashboard-participant-inner-detail'>

            {isAnomalous && (
                <>
                    <div className="progress-bar">
                        <div className="progress-inner1" style={{ width: `${anomaly}%` }}></div>
                        <div className="progress-inner2" style={{ width: `${warnings}%` }}></div>
                    </div>
                    
                    <div className='anamaly-indicator-text'>
                        <span className='label label-small'>{convertToHoursAndMinutes(cnt_pos)} Anomalies</span>
                        <span className='label label-small'>{convertToHoursAndMinutes(cnt_indeterminate)} Warnings</span>
                    </div>
                </>
            )}

        </div>
    );
};

export default DashboardParticipantInnerDetail;
